'use client';

import { useTranslations } from 'next-intl';

import { AnimatedButton } from '@/components/ui/animated-button';
import { EmptyState } from '@/components/ui/empty-state';
import { Alert01IconSolid, RotateClockwiseIcon } from '@/components/ui/icon/glyphs';

interface MarketsFeedErrorProps {
  readonly phase: 'initial' | 'stale';
  readonly onRetry: () => void;
}

export function MarketsFeedError({ phase, onRetry }: MarketsFeedErrorProps): React.ReactNode {
  const t = useTranslations('markets');

  if (phase === 'stale') {
    return (
      <div
        className="flex items-center justify-center gap-3 py-3 text-center"
        data-testid="markets-stale-error"
        aria-live="polite"
      >
        <p className="text-caption text-foreground-secondary">{t('error.title')}</p>
        <AnimatedButton variant="tertiary" size="sm" prefix={RotateClockwiseIcon} onClick={onRetry}>
          {t('error.retry')}
        </AnimatedButton>
      </div>
    );
  }

  return (
    <EmptyState
      size="page"
      icon={Alert01IconSolid}
      title={t('error.title')}
      data-testid="markets-error"
      action={
        <AnimatedButton variant="secondary" prefix={RotateClockwiseIcon} onClick={onRetry}>
          {t('error.retry')}
        </AnimatedButton>
      }
    />
  );
}
